import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit de la copropriété - Voisinage</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet d'avocats GAVA-<i>Lex</i> vous conseillera et vous défendra dans les dossiers de{' '}
					<strong>copropriété</strong> ainsi que dans les différends entre voisins.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous possédez ou habitez un immeuble par appartement, de multiples problèmes peuvent naître ; il
					en va de même avec les propriétaires ou occupants d'un bâtiment voisin.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Concernant le <strong>droit de la copropriété</strong>, le cabinet vous assistera pour tout litige
					relatif aux travaux, aux décomptes, aux décisions prises en assemblée générale ou au règlement de
					copropriété ainsi que pour tout différend entre copropriétaire et syndic ou entre membres de l'ACP
					(association des copropriétaires).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					De même, il accompagnera tant le syndic que les copropriétaires pour des actions en justice
					relatives par exemple aux charges ou au recouvrement de celles-ci.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Enfin, le cabinet peut vous défendre dans le cas de litige entre voisins ou de{' '}
					<strong>troubles de voisinage</strong>. Il pourra aussi vous assister en cas de recours à la
					médiation.{' '}
				</p>
				<div className='organigation-text w-[64%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Coproriété
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Syndic
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Appartements
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Litiges entre voisins
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
